import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge
const removeEmergentBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  
  // Also remove by href
  document.querySelectorAll('a[href*="emergent.sh"]').forEach(el => el.remove());
};

// Remove on load and observe for dynamic injection
removeEmergentBadge();
setInterval(removeEmergentBadge, 500);

const observer = new MutationObserver(removeEmergentBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
